/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import {channelDefState, privacyStatus} from './ChannelDefType';
import {BillingTypes} from './FlowDefType';
import {RequiredPayPlans, PayPlans} from './OrganisationType';
import config from '../../common/config';

export function scenarioRequiresPayPlan(scenario, organisationPayPlan) {
    let plan1 = RequiredPayPlans[scenario.requiredPayPlan];
    let plan2 = PayPlans[organisationPayPlan];

    let plan1Prio = plan1 ? plan1.priority : 10;
    let plan2Prio = plan2 ? plan2.priority : 10;

    if (plan2Prio >= plan1Prio) {
        return true;
    } else {
        return false;
    }
}


export default declareEntity({
    entity: "scenarios",
    graphQL: "Scenario",
    name: "Scenario",
    dynamoPrefix: 'def',
    storageType: 'schema',
    userEditable: false,
    defaultTitle: (data) => {
        return data['title'];
    },
    defaultOrder: ['title'],
    isPublic: true,
    fields: (types) => { return {
        id: {
            name: "Scenario Def ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            userEditable: false,
            filterable: true,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        title: {
            name: "Title",
            userEditable: false,
            filterable: true,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        description: {
            name: "Description",
            userEditable: false,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        longDescription: {
            name: "Long Description",
            userEditable: false,
            translatable: true,
            type: "html",
            isPublic: true,
        },
        urlFragment: {
            name: "URL Fragment",
            userEditable: false,
            type: "string",
            isPublic: true,
            filterable: true,
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            required: true,
            hiddenCreate: true,
            defaultValue: (scenarioDef) => {
                return scenarioDef['id'];
            },
            isPublic: true,
        },
        channelState: {
            name: "Channel State",
            type: "enum",
            filterable: true,
            userEditable: false,
            defaultValue: (scenarioDef) => {
                return scenarioDef['state'];
            },
            values: channelDefState,
            isPublic: true,
        },
        state: {
            name: "State",
            type: "enum",
            filterable: true,
            userEditable: false,
            defaultValue: (scenarioDef) => {
                return scenarioDef['state'];
            },
            values: channelDefState,
            isPublic: true,
        },
        deprecated: {
            name: "Is Deprecated?",
            type: "boolean",
            defaultValue: false,
            filterable: true,
            isPublic: true,
        },
        showContactUs: {
            name: "Show Contact Us",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        requiredPayPlan: {
            name: "Required Plan",
            type: "enum",
            isPublic: true,
            filterable: true,
            values: RequiredPayPlans,
        },
        extraPayment: {
            name: "Extra Payment",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        billingType: {
            name: "Billing type",
            isPublic: true,
            type: "enum",
            values: BillingTypes,
        },
        priceInstallation: {
            name: "Installation Price",
            type: "number",
            isPublic: true,
        },
        priceInstallationNext: {
            name: "Installation Price (another)",
            type: "number",
            isPublic: true,
        },
        priceSelfInstallation: {
            name: "Self Installation Price",
            type: "number",
            isPublic: true,
        },
        pricePerInvocation: {
            name: "Price per invocation",
            type: "number",
            isPublic: true,
        },
        invocationName: {
            name: "Invocation name",
            type: "string",
            translatable: true,
            isPublic: true,
        },
        pricePerInstance: {
            name: "Price per instance",
            type: "number",
            isPublic: true,
        },
        pricePerInstanceNext: {
            name: "Price per instance (more)",
            type: "number",
            isPublic: true,
        },
        priceText: {
            name: "Price text",
            type: "string",
            description: "Text showed to the user instead of computed text from price parameters. You can use pricePerInstance, pricePerInstanceNext, pricePerInvocation, priceInstallation, priceSelfInstallation, invocationName.",
            isPublic: true,
            translatable: true,
        },
        isInvalid: {
            name: "Is scenario invalid?",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        requiresExtension: {
            name: "Requires extension?",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        requiresCaching: {
            name: "Requires activated caching",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        requiresWritePermission: {
            name: "Requires write permission for API",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        privacy: {
            name: "Privacy",
            type: "enum",
            values: privacyStatus,
            isPublic: true,
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            filterable: true,
            userEditable: false,
            isPublic: true,
            defaultValue: (scenarioDef) => {
                return scenarioDef['visibility'];
            },
            values: {
                "private": {
                    name: "Private",
                },
                "unlisted": {
                    name: "Unlisted",
                },
                "public": {
                    name: "Public",
                },
            }
        },
        popularity: {
            name: "Popularity",
            type: "int",
            defaultValue: 1,
            isPublic: true,
            import: false,
            export: false,
        },
        developerGroup: {
            name: "Developer",
            type: "relation",
            to: () => types['developerGroups'],
            defaultValue: config.DEVELOPER_DATIVERY,
            filterable: true,
            userEditable: false,
            isPublic: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
            defaultValue: (scenarioDef) => {
                return scenarioDef['author_id'];
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        scenarios2ChannelDefs: {
            type: 'oneToMany',
            export: true,
            to: types['scenarios2ChannelDefs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "scenario_id"
                }
            ],
            isPublic: true,
        },
        flows: {
            type: 'oneToMany',
            to: types['flows'],
            foreignKeys: [
                {
                    from: "id",
                    to: "scenario_id",
                    asFilterOnly: true,
                }
            ]
        },
        organisations: {
            type: 'oneToMany',
            to: types['organisations'],
            controllerFn: 'getUsedOrganisations',
        },
        scenarios2SourceDefs: {
            type: 'oneToMany',
            export: true,
            to: types['scenarios2SourceDefs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "scenario_id"
                }
            ],
        },

    }; }
});
